export default __webpack_public_path__ + "static/share-7ff07f58bbec44a063dabf9d1beeef69.jpg";